import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR }

export const SET_FILTERED_AND_SORTED_INVOICES = "SET_FILTERED_AND_SORTED_INVOICES";

export const SET_SELECTED_TYPE = "SET_INVOICE_SELECTED_TYPE";
export const SET_SELECTED_STATE = "SET_INVOICE_SELECTED_STATE";
export const SET_START_DATE = "SET_INVOICE_START_DATE";
export const SET_END_DATE = "SET_INVOICE_END_DATE";
export const SET_MIN_AMOUNT = "SET_MIN_AMOUNT";
export const SET_MAX_AMOUNT = "SET_MAX_AMOUNT";
export const SET_NUMBER_INPUT = "SET_NUMBER_INPUT";
export const SET_DISPLAY_AS_LIST = "SET_DISPLAY_AS_LIST";

export const SET_TOTAL_UNTAXED_AMOUNT = "SET_INVOICE_TOTAL_UNTAXED_AMOUNT";
export const SET_TOTAL_AMOUNT = "SET_INVOICE_TOTAL_AMOUNT";

export const NB_MAX_INVOICES_TO_DISPLAY = 3;

export const OUT_REFUND = "out_refund";
export const OUT_INVOICE = "out_invoice";